import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { truncate } from 'lodash';
import { Observable } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';

declare var $: any, moment: any

@Component({
  selector: 'app-customer-profile',
  templateUrl: './customer-profile.component.html',
  styleUrls: ['./customer-profile.component.scss']
})
export class CustomerProfileComponent implements OnInit {

  contactId = ""

  submitted = false

  isEndCase = false

  isCrisis = true
  crm06: any = {}

  idNoSearchDROS: string
  accNoSearchDROS: string

  isNDID = false
  isDOPA = false
  isAgentBank = false
  dpa_allowemail = false
  dpa_allowsms = false
  dpa_pdpa_flag = false
  contactToDros: any

  smsTmpList: any
  emailTmpList: any
  caseTypeList: any
  subTypeTmpList: any
  caseSubTypeList: any
  caseChannelList: any
  caseStatusList: any
  caseSeverityList: any
  subTypeDetailTmpList: any
  caseSubTypeDetailList: any

  createdon: any
  modifiedon: any
  createBy = ""
  modifiedBy = ""

  createContactOn: any
  modifyContactOn: any
  createContactBy = ""
  modifyContactBy = ""

  form: FormGroup

  role: any = {}
  cookieData: any

  agentList: any = []
  userIdReceive = ""
  userList: any = []
  forwardRemark = ""
  submittedForward = false
  forwardTeam: any

  bankList: any
  approvalTicket: any

  teamList: any

  kmCriteria = ""
  matchKmType: any
  matchKm: any
  kmList: any
  showingKBList: any = []

  myTeams: any

  foundDROS: false

  isRemarkRequired = false
  isResolvedRequired = false

  oldEmail = ""

  //personalTypeList: any = {}
  stakeHolderList: any = []

  @Output() GetDataSave = new EventEmitter();

  constructor(
    private apiService: ApiService,
    private util: UtilService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.form = this.fb.group({
      contactid: "",
      dpa_contacttype: "",
      firstname: "",
      lastname: "",
      dpa_stakeholderid: "",
      dpa_idcard: "",
      dpa_passport: "",
      birthdate: "",
      dpa_companyname: "",
      dpa_registrationdate: "",
      dpa_authorizedperson: "",
      dpa_authorizedperson_idcard: "",
      dpa_authorizedperson_telephone: "",
      telephone1: ['', Validators.required],
      dpa_otherphone: "",
      emailaddress1: ['', this.emailValidator],
      dpa_contact_homeno: "",
      dpa_contact_building: "",
      dpa_contact_moo: "",
      dpa_contact_street: "",
      dpa_contact_subdistict: "",
      dpa_contact_distict: "",
      dpa_contact_province: "",
      dpa_contact_postcode: "",
      dpa_contact_country: "",
      dpa_registration_homeno: "",
      dpa_registration_building: "",
      dpa_registration_moo: "",
      dpa_registration_street: "",
      dpa_registration_subdistict: "",
      dpa_registration_distict: "",
      dpa_registration_province: "",
      dpa_registration_postcode: "",
      dpa_registration_country: "",
      dpa_dopaflag: "",
      dpa_ndidflag: "",
      dpa_agentbankflag: "",
      dpa_verifydate: "",
      dpa_facebookflag: "",
      dpa_googleflag: "",
      dpa_lineflag: "",
      statusreason: "",

      incidentid: "",
      ticketnumber: "",
      title: "",
      customerid: "",
      dpa_casetypeid: ['', Validators.required],
      dpa_casesubtypeid: ['', Validators.required],
      dpa_casesubtypedetailid: ['', Validators.required],
      dpa_casechannelid: new FormControl({value: '', disabled: true}, Validators.required),
      dpa_caseseverityid: ['', Validators.required],
      description: ['', Validators.required],
      dpa_remark: "",
      dpa_casestatusid: ['', Validators.required],
      dpa_resolveddate: "",
      dpa_createdby: "",
      dpa_modifiedby: "",
      dpa_caseowner: "",
      dpa_resolveby: "",
      dpa_assignby: "",
      dpa_resolution: "",
      dpa_owningteamid: "",
      dpa_allowemail:false,
      dpa_allowsms:false,
      dpa_pdpa_flag:false


    });
  }

  async ngOnInit() {
    const thisTs = this
    this.util.InitValidation()
    console.log("profile on init")

    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.role = JSON.parse(this.cookieData.role)
    console.log(this.role)
    this.myTeams = JSON.parse(this.cookieData.teams)
    this.isCrisis = this.cookieData.isCrisis

    this.contactId = this.activatedRoute.snapshot.paramMap.get('id');

    if(this.isCrisis){
      this.crisis()
    }
    else{
      this.normal()
    }

    await this.initDropdown()

    $("#userIdReceive").on("change", function () {
      thisTs.userIdReceive = $("#userIdReceive").find('option:selected').val()
    })

    
    $("#ra2")[0].checked = true
    
    $("#ra1").on("click", function () {
      $("#ra1")[0].checked = true
      $("#ra2")[0].checked = false
    })

    $("#ra2").on("click", function () {
      $("#ra1")[0].checked = false
      $("#ra2")[0].checked = true
    })
  }

  init(contact: any){
    let contacts: any = []
    contacts.push(contact)
    this.initViewMode(contacts)
  }

  

  async initDropdown() {

    Observable.forkJoin(
      this.apiService.get("master", "caseChannel"),
      this.apiService.get("master", "caseStatus"),
      this.apiService.get("master", "caseSeverity"),
      this.apiService.get("master", "caseType"),
      this.apiService.get("master", "caseSubType"),
      this.apiService.get("master", "stakeHolders"),
      this.apiService.get("master", "caseSubTypeDetail"),
      this.apiService.get("master", "callcenterTeam"),
      this.apiService.get("crmservice", "contact", "contactid=" + this.contactId)
    ).subscribe(
      async data => {

        this.caseChannelList = data[0]
        this.caseStatusList =  data[1]
        this.caseSeverityList =  data[2]
        this.caseTypeList = data[3]
        this.subTypeTmpList = data[4]
        this.stakeHolderList = data[5]
        let tmpSubTypeDetail: any = data[6]
        this.teamList = data[7]
        let contact: any = data[8]
        this.contactToDros =  data[8]
        
    let para = ""
    this.teamList.forEach((t: any) => {
      if(para != ""){
        para += "&"
      }     
      para += "callcenterteam=" + t.dpa_callcenterteamid
    });
    
    this.agentList =  await this.apiService.get("crmservice", "callcenterProfile", para)

        this.subTypeDetailTmpList = tmpSubTypeDetail.filter((s: any) => {
          return !s.dpa_issendemail
        })
        let channel = this.caseChannelList.filter((ch: any) => {
          return ch.dpa_name.replace(" ", "").toLowerCase() == "callcenter"
        })
        if (channel == null || channel.length > 0) {
          this.form.controls["dpa_casechannelid"].setValue(channel[0].dpa_casechannelid)
        }
    
        let status = this.caseStatusList.filter((ch: any) => {
          return ch.dpa_name.replace(" ", "").toLowerCase() == "new"
        })
    
        if (status == null || status.length > 0) {
          this.form.controls["dpa_casestatusid"].setValue(status[0].dpa_casestatusid)
        }

        this.initViewMode(contact)

        this.util.ShowWaiting(false)
      },
      err => console.error(err)
    );
  }

  async forward() {
    this.submitted = true;
    if ((this.isRemarkRequired && this.formControl["dpa_remark"].value.trim().length == 0) ||
    (this.isResolvedRequired && this.formControl["dpa_resolution"].value.trim().length == 0)) {
      return
    }
    else {
      if (this.form.valid) {

        let caseStatus: any = this.caseStatusList.filter((s: any) => {
          return s.dpa_casestatusid == this.formControl["dpa_casestatusid"].value
        })

        if (caseStatus != null && caseStatus.length > 0 && (caseStatus[0].dpa_name.toLowerCase() == "new" || caseStatus[0].dpa_name.toLowerCase() == "inprogress")) {

          try {
            let caseForwardSubTypeDetail: any = this.subTypeDetailTmpList.filter((st: any) => {
              return st.dpa_casesubtypedetailid == this.formControl["dpa_casesubtypedetailid"].value
            })
            
            //console.log(caseForwardSubTypeDetail)
            let matchTeam: any = this.teamList.filter((t: any) => {
              return t.dpa_callcenterteamid == caseForwardSubTypeDetail[0].dpa_teamownerid
            })
            if (matchTeam != null && matchTeam.length > 0) {
              this.forwardTeam = caseForwardSubTypeDetail[0].dpa_teamownerid
              await this.onForwardTeamChange()
    
              let matchUser: any = this.userList.filter((u: any) => {
                return u.dpa_customwebuserid == caseForwardSubTypeDetail[0].dpa_caseownerid
              })
              if (matchUser != null && matchUser.length > 0) {
                this.userIdReceive = caseForwardSubTypeDetail[0].dpa_caseownerid
              }
              else{
                this.userIdReceive = ""
              }
            }
            else{
              this.forwardTeam = ""
            }

          }
          catch (e) {
            console.log("ไม่สามารถกำหนดค่าเริ่มต้นได้")
            this.forwardTeam = ""
            await this.onForwardTeamChange()
            this.userIdReceive = ""

          }

          this.submittedForward = false
          this.forwardRemark = ""
          $("#forwardModal").modal('show')
        }
        else {
          this.util.WarningDialog("กรุณาเลือกเฉพาะรายการที่มีสถานะเป็น New หรือ Inprogress เท่านั้น")
        }
      }
    }
  }

  confirmForward() {
    this.submittedForward = true

    if (this.forwardTeam != null && this.forwardTeam.trim() != "" && this.forwardRemark != null && this.forwardRemark.trim() != "") {
      this.form.controls["dpa_owningteamid"].setValue(this.forwardTeam)
      this.form.controls["dpa_caseowner"].setValue(this.userIdReceive)
      this.form.controls["dpa_assignby"].setValue(this.cookieData.userId)
      this.form.controls["dpa_remark"].setValue(this.forwardRemark)

      this.save(false, true)
    }
  }

  CloseModal(modalId: string) {
    $("#" + modalId).modal("hide")
  }

  normal() {
    $(".crisis").hide()
  }

  crisis() {
    $(".crisis").show()
  }

  viewAccountList() {
    $("#accountListModal").modal("show")
  }

  close() {
    window.close()
  }

  emailValidator(control: any) {
    if (control.value) {
      const matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
      return matches ? null : { 'invalidEmail': true };
    } else {
      return null;
    }
  }

  async initViewMode(contact: any) {

    this.GetDataSave.emit(contact[0]);

    this.accNoSearchDROS = contact[0].dpa_accountno

    this.mapDataToForm(contact[0])

    let idNo = ""
    if(contact[0]["dpa_idcard"] != null && contact[0]["dpa_idcard"].trim().length > 0){
      idNo = contact[0]["dpa_idcard"]
    }
    else if(contact[0]["dpa_passport"] != null && contact[0]["dpa_passport"].trim().length > 0){
      idNo = contact[0]["dpa_passport"]
    }
    else if(contact[0]["dpa_registrationid"] != null && contact[0]["dpa_registrationid"].trim().length > 0){
      idNo = contact[0]["dpa_registrationid"]
    }

    this.getDrosContact(idNo, contact[0]["telephone1"])

    
    this.approvalTicket = await this.apiService.get("crmservice", "searchApprovalTicket", "contactid=" + this.contactId)

    this.isDOPA = contact[0].dpa_dopaflag
    this.isNDID = contact[0].dpa_ndidflag
    if(this.approvalTicket != null && this.approvalTicket.length > 0 && 
      this.approvalTicket[0].dpa_approvalstatuscode != null &&
      this.approvalTicket[0].dpa_approvalstatuscode == "03"){
        this.isAgentBank = true
      }
      else{
        this.isAgentBank = false
      }

    this.createdon = new Date()
    this.modifiedon = new Date()
    this.form.controls["dpa_createdby"].setValue(this.cookieData.userId)
    this.form.controls["dpa_modifiedby"].setValue(this.cookieData.userId)
    this.createBy = this.cookieData.dpa_name
    this.modifiedBy = this.cookieData.dpa_name
    this.form.controls["dpa_caseowner"].setValue(this.cookieData.userId)


    this.form.controls["firstname"].setValue(contact[0]["firstname"])
    this.form.controls["lastname"].setValue(contact[0]["lastname"])
    this.form.controls["telephone1"].setValue(contact[0]["telephone1"])
    this.form.controls["dpa_otherphone"].setValue(contact[0]["dpa_otherphone"])
    this.form.controls["emailaddress1"].setValue(contact[0]["emailaddress1"])
     
    this.dpa_allowsms =  contact[0]["dpa_allowsms"]
    this.dpa_allowemail =  contact[0]["dpa_allowemail"]
    this.dpa_pdpa_flag = contact[0]["dpa_pdpa_flag"]
    this.createContactOn = contact[0]["createdon"]
    this.createContactBy = contact[0]["dpa_createdbyname"]
    this.modifyContactOn = contact[0]["modifiedon"]
    this.modifyContactBy = contact[0]["dpa_modifiedbyname"]

    this.form.controls["customerid"].setValue(this.contactId)
    this.form.controls["contactid"].setValue(this.contactId)

    if( this.dpa_pdpa_flag ){
      $("#ra1")[0].checked = true
      $("#ra2")[0].checked = false
    }else {
      $("#ra1")[0].checked = false
      $("#ra2")[0].checked = true
    }
    
    this.util.ShowWaiting(false)
  }

  get formControl() {
    return this.form.controls;
  }

  get email() {
    return this.form.value.emailaddress1.trim()
  }

  async onForwardTeamChange() {
    let tmp: any = await this.agentList.filter((a: any) => {
      return a.dpa_teamidlist.map((ag: any) => { return ag.dpa_callcenterteamid }).indexOf(this.forwardTeam) > -1
    })

    this.userList = []
    tmp.forEach((a: any) => {
      if(this.userList.indexOf(a) == -1 && a.dpa_customwebuserid != this.cookieData.userId){
        this.userList.push(a)
      }
    });
  }

  async save(close: boolean = false, closeForward: boolean = false) {
    this.submitted = true;
    if ((this.isRemarkRequired && this.formControl["dpa_remark"].value.trim().length == 0) ||
      (this.isResolvedRequired && this.formControl["dpa_resolution"].value.trim().length == 0)) {
      return
    }

    if (this.form.valid) {

      //set team
      if(this.myTeams != null && this.myTeams.length > 0){
        this.formControl["dpa_owningteamid"].setValue(this.myTeams[0].dpa_callcenterteamid)
      }
      else{
        this.formControl["dpa_owningteamid"].setValue(null)
      }//set team
      
    this.form.controls["dpa_pdpa_flag"].setValue($('#ra1')[0].checked)
    

      this.util.ShowWaiting(true)
      if (await this.updateContact()) {
        
         await this.registerDROS();
        this.GetDataSave.emit(this.form.getRawValue());

        if(this.formControl["incidentid"].value != null && this.formControl["incidentid"].value != ""){

          //update for tester request
          if (await this.updateCase()) {
            this.checkIsSaveCloseCase()
            this.util.ShowWaiting(false)
            if (closeForward) {
              this.util.SuccessDialog("ส่งต่อ Case สำเร็จ")
            }
            else {
              this.util.SuccessDialog("บันทึก case สำเร็จ")
            }
            if (close) {
              window.close();
            }
            if (closeForward) {
              $("#forwardModal").modal('hide')
            }
          }
          else {
            this.util.ShowWaiting(false)
          }

          if (this.oldEmail != null && this.oldEmail != "" && this.oldEmail != this.formControl["emailaddress1"].value) {

            let updateSucceed = this.updatePortalLogin()

            // this.SendNewEmail()
            // this.SendOldEmail()

            let notiReq = {
              firstname: this.formControl["firstname"].value,
              lastname: this.formControl["lastname"].value,
              callBy: "1",
              newMail: this.formControl["emailaddress1"].value,
              oldMail: this.oldEmail
            }
            this.apiService.postCustom("crm", "NotiEmailChange", notiReq)
          }
          //end update
        }
        else{
          if (await this.createCase()) {
            this.checkIsSaveCloseCase()
            this.util.ShowWaiting(false)
            if (closeForward) {
              this.util.SuccessDialog("ส่งต่อ Case สำเร็จ")
            }
            else {
              this.util.SuccessDialog("เพิ่ม case สำเร็จ")
            }
            if (close) {
              window.close();
            }
            if (closeForward) {
              $("#forwardModal").modal('hide')
            }
          }
          else {
            this.util.ShowWaiting(false)
          }

          if (this.oldEmail != null && this.oldEmail != "" && this.oldEmail != this.formControl["emailaddress1"].value) {

            let updateSucceed = this.updatePortalLogin()

            // this.SendNewEmail()
            // this.SendOldEmail()

            let notiReq = {
              firstname: this.formControl["firstname"].value,
              lastname: this.formControl["lastname"].value,
              callBy: "1",
              newMail: this.formControl["emailaddress1"].value,
              oldMail: this.oldEmail
            }
            this.apiService.postCustom("crm", "NotiEmailChange", notiReq)
          }
        }
      }
      else {
        if (closeForward) {
          this.util.ErrorDialog("ส่งต่อ Case ไม่สำเร็จ")
        }
        else {
          this.util.ErrorDialog("เพิ่ม case ไม่สำเร็จ")
        }
        this.util.ShowWaiting(false)
      }
    }
  }

  async createCase() {
    var res: any = await this.apiService.post("crmservice", "caseIncident", this.form.getRawValue(), true);
    if (this.util.isSuccessResponse(res)) {
      this.formControl["incidentid"].setValue(res.incidentid)
      return true
    } else {
      //this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ")
      return false
    }
  }

  async updateContact() {
    var res: any = await this.apiService.put("crmservice", "contact/" + this.form.get("contactid").value, this.form.getRawValue());
    if (!this.util.isSuccessResponse(res)) {
      //this.util.ErrorDialog("แก้ไข Contact ไม่สำเร็จ")
      return false
    }
    else {
      return true
    }
  }

  onCaseTypeChange() {
    this.caseSubTypeList = this.subTypeTmpList.filter(
      (subType: any) => subType.dpa_casetypeid === this.form.get("dpa_casetypeid").value)
    this.form.get("dpa_casesubtypeid").setValue("")

    this.onCaseSubTypeChange()
  }

  onCaseSubTypeChange() {
    this.caseSubTypeDetailList = this.subTypeDetailTmpList.filter((s: any) => {
      return s.dpa_casesubtypeid === this.form.get("dpa_casesubtypeid").value
    })

    this.form.get("dpa_casesubtypedetailid").setValue("")
  }

  filterByType(type: number) {
    this.util.ShowWaiting(true)
    this.showingKBList = this.kmList.filter(
      (kb: { dpa_knowledgebasetype: any; }) => {
        if (type === kb.dpa_knowledgebasetype) {
          return true
        }
      })
    this.util.ShowWaiting(false)
  }

  filterKm() {
    this.util.ShowWaiting(true)
    this.kmCriteria = $("#kmCriContact").val()
    if (this.kmCriteria != null && this.kmCriteria.trim().length == 0) {
      this.showingKBList = []
    }
    else {
      this.showingKBList = this.kmList.filter(
        (kb: { dpa_keyword: any; }) => {
          if (kb.dpa_keyword != null && kb.dpa_keyword.includes(this.kmCriteria)) {
            return true
          }
        })
    }
    this.util.ShowWaiting(false)
  }

  onCaseStatusChange() {
    let status = this.caseStatusList.filter((c: any) => {
      return c.dpa_casestatusid == this.form.controls["dpa_casestatusid"].value
    })
    if(status != null && status.length > 0){

      if(status[0].dpa_code == "04"){
        this.isRemarkRequired = true
      }
      else{
        this.isRemarkRequired = false
      }
      if(status[0].dpa_code == "03"){
        this.isResolvedRequired = true
      }
      else{
        this.isResolvedRequired = false
      }
    }
  }

  mapDataToForm(data: any) {
    Object.keys(data).forEach((key) => {
      if (this.form.controls[key]) {
        this.form.controls[key].setValue(data[key])
      }
      else {
        this.form.addControl(key, new FormControl(data[key]));
      }
    });
  }

  openKm() {
    const url = this.util.baseUrl() + `/mainmenu/knowledge/`
    window.open(url, '_blank');
  }

  checkIsSaveCloseCase(){
    if(this.isRemarkRequired  ||  this.isResolvedRequired){
      this.isEndCase = true
      $("#form :input").prop("disabled", true);
      $("#btnKm").prop("disabled", false);
    }
  }

  async drawDepositAccountTable(accountList: any = null){
    try{
      $('#tbSharedCase').DataTable().clear().destroy();
    }
    catch(e){

    }
    $("#accountTable tbody").empty()

    if(accountList != null){
      
      this.bankList = await this.apiService.get("master", "bank")
      accountList.forEach((b: any) => {
        let tr = "<tr>"
        let bankName = this.bankList.filter((mb: any) => {
          return mb.dpa_bankcode == b.BankCode
        })
        if(bankName != null && bankName.length > 0){
          tr += "<td>" + (bankName[0].dpa_name || "") + "</td>"
        }
        else{
          tr += "<td></td>"
        }
      tr += "<td>" + (b.BankAccountNo || "") + "</td>"
      tr += "<td>" + (b.BankAccountName || "") + "</td>"
      // tr += "<td>" + (b.BankCode || "") + " </td>"
      tr += "<td>" + (b.BankAccountStatus || "") + "</td>"
      tr += "<td>" + (b.BankAccountType || "") + "</td>"
      tr += "</tr>"

      $("#accountTable tbody").append(tr)
      });
    }

    $("#accountTable").dataTable({
      retrieve: true,
      'searching': false,
      'paging': true
    })
  }

  async getDrosContact(idNo: string, phoneNo: string, accNo: string = null){
    let para = "CRM06=true&CRM07=true"
    if(idNo != null && idNo.trim().length != 0){
      para += "&dpa_id=" + idNo
    }
    if(phoneNo != null && phoneNo.trim().length != 0){
      para += "&telephoneno=" + phoneNo
    }
    if(accNo != null && accNo.trim().length != 0){
      para += "&dpa_accountno=" + accNo
    }

    if(para == "CRM06=true&CRM07=true"){
      return
    }
    else{
      let contactDros: any = await this.apiService.get("crmservice", "contactDros", para)
      this.util.ShowWaiting(false)
      if(contactDros == null || contactDros.length == 0){
        //this.util.WarningDialog("ไม่พบข้อมูลใน DROS")
      }
      else{
        if(contactDros != null && contactDros.CRM06 != null){
          this.crm06 = contactDros.CRM06
          this.idNoSearchDROS = contactDros.CRM06.IDNo
        }
        else{
          this.crm06 = {}
        }
    
        if(contactDros != null && contactDros.CRM07 != null){
          await this.drawDepositAccountTable(contactDros.CRM07)
        }
        else{
          await this.drawDepositAccountTable()
        }
      }
    }
  }

  async registerDROS() {
    let idcard = this.contactToDros[0].dpa_idcard;
    let para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false&CRM06=true";
    let tmp: any = await this.apiService.get("crmservice", "contactDros", para);
    if (!this.util.IsNullOrUndefined(tmp.CRM06)) {
      let UID = tmp.CRM06.UID;
      let SubdistictCode: string = "";
      let PostalName: string = "";
      let SubdistictObj = await this.apiService.postCustomApi("master", "Subdistrict", { id: this.contactToDros[0].dpa_contact_subdistict});
      let PostalObj = await this.apiService.postCustomApi("master", "Postalcode", { id: this.contactToDros[0].dpa_contact_postcode });
      if (!this.util.IsNullOrUndefined(SubdistictObj)) { SubdistictCode = SubdistictObj[0].dpa_code; }0
      if (!this.util.IsNullOrUndefined(PostalObj)) { PostalName = PostalObj[0].dpa_name; }
      let arrAddr: any = [];
      let rowAddr: any = {
        addressType: "2",
        addressNo: this.contactToDros[0].dpa_contact_homeno,
        villageName: null,
        floor: null,
        mooNo: this.contactToDros[0].dpa_contact_moo,
        soiName: null,
        streetName: this.contactToDros[0].dpa_contact_street,
        locationCode: SubdistictCode,
        zipcode: PostalName
      }

     let birthdateYYYYMMDD = ""
     if(this.contactToDros[0].birthdate != "")
     {
      birthdateYYYYMMDD = moment(this.contactToDros[0].birthdate).format("YYYY/MM/DD") ;
     }

      arrAddr.push(rowAddr);
      let rowSave: any = {
        uid: UID,
        idNo: idcard,
        title: null,
        firstName:  this.formControl["firstname"].value ,
        lastName:  this.formControl["lastname"].value,
        birthdate: birthdateYYYYMMDD ,
        mobileNo:  this.formControl["telephone1"].value,
        email: this.formControl["emailaddress1"].value,
        address: arrAddr
      }
      //console.log(rowSave);
      let Res = await this.apiService.post("DROS", "register", rowSave);
      //console.log(Res);


    }

  }

  // async SendNewEmail() {
    
  //   let MailObj: any = {
  //     dpa_name: "อีเมลของท่านได้รับการเปลี่ยนแล้ว",
  //     dpa_emailaddress: this.formControl["emailaddress1"].value
  //   };

  //   var MailContent = "เรียน คุณ" + this.formControl["firstname"].value + " " + this.formControl["lastname"].value + "<br /><br />" +
  //     "   อีเมลนี้ของคุณได้รับการบันทึกในระบบ Call Center ของสถาบันคุ้มครองเงินฝาก <br />" +
  //     "หากท่านไม่ได้เป็นผู้ดำเนินการ กรุณาติดต่อเจ้าหน้าที่โดยเร็วที่สุด  <br /><br />" +
  //     "ขอแสดงความนับถือ <br />" +
  //     "สถาบันคุ้มครองเงินฝาก <br />" +
  //     "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
  //     "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
  //     "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
  //     "โทร : 02-272-0300";
  //   MailObj.dpa_description = MailContent;
  //   MailObj.dpa_callby = 1
  //   let Res = await this.apiService.post("crmservice", "sendEmail", MailObj);
  //   return Res;
  // }

  // async SendOldEmail() {

  //   let MailObj: any = {
  //     dpa_name: "อีเมลของท่านได้ถูกเปลี่ยนแล้ว",
  //     dpa_emailaddress: this.oldEmail
  //   };

  //   var MailContent = "เรียน คุณ" + this.formControl["firstname"].value + " " + this.formControl["lastname"].value + "<br /><br />" +
  //     "   อีเมลของคุณได้เปลี่ยนในระบบ Call Center ของสถาบันคุ้มครองเงินฝาก <br />" +
  //     "หากท่านไม่ได้เป็นผู้ดำเนินการ กรุณาติดต่อเจ้าหน้าที่โดยเร็วที่สุด <br /><br />" +
  //     "ขอแสดงความนับถือ <br />" +
  //     "สถาบันคุ้มครองเงินฝาก <br />" +
  //     "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
  //     "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
  //     "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
  //     "โทร : 02-272-0300";
  //   MailObj.dpa_description = MailContent;
  //   MailObj.dpa_callby = 1
  //   let Res = await this.apiService.post("crmservice", "sendEmail", MailObj);
  //   return Res;
  // }

  async updatePortalLogin(){
    let req: any = {
      username: this.formControl["emailaddress1"].value,
      usernameidno: this.formControl["dpa_idcard"].value,
      oldEmail: this.oldEmail
    }

    let res: any = await this.apiService.postCustom("User", "UpdateEmailLogin", req)

    if(this.util.isSuccessResponse(res)){
      return true
    }
    else{
      return false
    }
  }

  async updateCase() {
    var res = await this.apiService.put("crmservice", "caseIncident/" + this.form.get("incidentid").value, this.form.getRawValue());
    if (this.util.isSuccessResponse(res)) {
      return true
    } else {
      return false
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/customer-profile/customer-profile.component.ts